module.exports = {
  headline: 'Not Available',
  text: 'This page has intentionally been left out.',
};


// WEBPACK FOOTER //
// ./pages/content/comingSoon_EN.js